import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isNil, isString } from 'lodash';
import { FaroService } from '../services/config/faro.service';

const commonApiResponseMessage = 'Something went wrong!';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(private faroService: FaroService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((browserError: HttpErrorResponse) => {
        const handledError = { error: { message: commonApiResponseMessage } };
        if (isNil(browserError.error) || isString(browserError.error)) {
          browserError = Object.assign(browserError, handledError);
        }
        this.faroService.pushError(new Error(browserError.message), {
          context: { status: String(browserError.status), url: req.url },
        });
        return throwError(browserError);
      }),
    );
  }
}
